import { ExclamationCircleOutlined } from '@ant-design/icons';
import { ScopeButton } from '@monorepo/shared-lib';
import GenTaxImage from 'assets/images/gen-tax-img-cropped.svg';
import { StyledCard } from 'components/Custom/card';
import { CardDescSpan, CardTitleLargeSpan } from 'components/Custom/spans';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePwaMobileNavEnabled } from 'utils/usePwaMobileNavEnabled';
interface EntityNotConnectedPanelProps {
  onReconnect: () => void;
  marginBottom?: string;
  maxWidth?: number | string;
}

export const EntityNotConnectedPanel: React.FC<EntityNotConnectedPanelProps> = ({
  onReconnect,
  marginBottom = '20px',
  maxWidth = 1150,
}) => {
  const { t } = useTranslation();
  const pwaMobileNav = usePwaMobileNavEnabled();

  return (
    <StyledCard
      $nopadding
      fullsize
      width="100%"
      className={
        pwaMobileNav ? 'scope-pwa-entity-not-connected-panel' : undefined
      }
      style={{
        border: '1px solid var(--color-status-danger, #D13131)',
        boxShadow: '0px 4px 10px 0px #0000000D',
        marginBottom,
        display: 'flex',
        fontSize: 14,
        fontWeight: 400,
        padding: 0,
        maxWidth,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
      }}
    >
      <div
        className={
          pwaMobileNav
            ? 'scope-pwa-entity-not-connected-panel__layout'
            : undefined
        }
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexFlow: pwaMobileNav ? 'column' : 'row',
          alignContent: 'end',
          padding: pwaMobileNav ? '16px 0' : '24px 24px 0 0',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <div
          className={
            pwaMobileNav
              ? 'scope-pwa-entity-not-connected-panel__content'
              : undefined
          }
          style={{
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'space-between',
            padding: pwaMobileNav ? 0 : '0 24px 24px 24px',
            width: pwaMobileNav ? '100%' : undefined,
            minWidth: 0,
          }}
        >
          <div className="scope-entity-not-connected-panel__title">
            <ExclamationCircleOutlined aria-hidden />
            <CardTitleLargeSpan className="scope-entity-not-connected-panel__title-text">
              {t('organisation.entity-not-connected-panel-title')}
            </CardTitleLargeSpan>
          </div>
          <CardDescSpan style={{ marginBottom: 16 }}>
            {t('organisation.entity-not-connected-panel-body')}
            <br />
            {t('organisation.entity-not-connected-panel-prompt')}
          </CardDescSpan>
          <ScopeButton
            type="primary"
            width={pwaMobileNav ? '100%' : 'fit-content'}
            height="40px"
            style={{ fontSize: '13px', fontWeight: 700 }}
            onClick={onReconnect}
          >
            {t('organisation.reconnect-entity')}
          </ScopeButton>
        </div>

        <img
          alt={t('vat-report.vat-checker-image-alt')}
          src={GenTaxImage}
          className={
            pwaMobileNav
              ? 'scope-pwa-entity-not-connected-panel__art'
              : undefined
          }
        />
      </div>
    </StyledCard>
  );
};
